//スクロールした際の動きを関数でまとめる
function PageTopAnime() {

    var scroll = $(window).scrollTop(); //スクロール値を取得
    if (scroll >= 200) { //200pxスクロールしたら
        $('#pagetop').removeClass('DownMove'); // DownMoveというクラス名を除去して
        $('#pagetop').addClass('UpMove'); // UpMoveというクラス名を追加して出現
    } else { //それ以外は
        if ($('#pagetop').hasClass('UpMove')) { //UpMoveというクラス名が既に付与されていたら
            $('#pagetop').removeClass('UpMove'); //  UpMoveというクラス名を除去し
            $('#pagetop').addClass('DownMove'); // DownMoveというクラス名を追加して非表示
        }
    }

    var wH = window.innerHeight; //画面の高さを取得
    var footerPos = $('#footer').offset().top; //footerの位置を取得
    if (scroll + wH >= (footerPos + 10)) {
        var pos = (scroll + wH) - footerPos + 10 //スクロールの値＋画面の高さからfooterの位置＋10pxを引いた場所を取得し
        $('#pagetop').css('bottom', pos); //#pagetopに上記の値をCSSのbottomに直接指定してフッター手前で止まるようにする
    } else { //それ以外は
        if ($('#pagetop').hasClass('UpMove')) { //UpMoveというクラス名がついていたら
            $('#pagetop').css('bottom', '10px'); // 下から10pxの位置にページリンクを指定
        }
    }
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function() {
    PageTopAnime(); /* スクロールした際の動きの関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function() {
    PageTopAnime(); /* スクロールした際の動きの関数を呼ぶ*/
});

// #pagetopをクリックした際の設定
$('#pagetop').click(function() {
    $('body,html').animate({
        scrollTop: 0 //ページトップまでスクロール
    }, 500); //ページトップスクロールの速さ。数字が大きいほど遅くなる
    return false; //リンク自体の無効化
});





//リンク先のidまでスムーススクロール
//※ページ内リンクを行わない場合は不必要なので削除してください
$('#g-navi li a').click(function() {
    var headerVal = $("#header").outerHeight(true); //現在のheaderの高さを取得    

    //ヘッダーが高さの状態を取得してスクロールする範囲を調整する
    var scroll = $(window).scrollTop(); //スクロール
    var adjust = 0 //調整の変数
    if (scroll <= headerVal) { //スクロールとヘッダーの高さを取得
        adjust = 70; //スクロール値がヘッダーの高さ以内であれば調整変数に70を入れる
    }

    var elmHash = $(this).attr('href'); //hrefを取得
    var pos = $(elmHash).offset().top - headerVal - adjust; //クリックしたheader分の高さと調整分を引いた高さまでスクロール

    $('body,html').animate({ scrollTop: pos }, 1000);
    return false;
});





// ハンバーガーメニュー3本線
$(".openbtn").click(function() { //ボタンがクリックされたら
    $(this).toggleClass('active'); //ボタン自身に activeクラスを付与し
    $("#g-nav").toggleClass('panelactive'); //ナビゲーションにpanelactiveクラスを付与
});

$("#g-nav a").click(function() { //ナビゲーションのリンクがクリックされたら
    $(".openbtn").removeClass('active'); //ボタンの activeクラスを除去し
    $("#g-nav").removeClass('panelactive'); //ナビゲーションのpanelactiveクラスも除去
});





// スライダー
$('.slider').slick({
    autoplay: true, //自動的に動き出すか。初期値はfalse。
    infinite: true, //スライドをループさせるかどうか。初期値はtrue。
    slidesToShow: 2, //スライドを画面に3枚見せる
    slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
    // prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
    // nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
    dots: true, //下部ドットナビゲーションの表示
    arrows: false,
    centerMode: true, //追記
    centerPadding: "20%", //追記
    responsive: [{
            breakpoint: 960, //モニターの横幅が769px以下の見せ方
            settings: {
                slidesToShow: 2, //スライドを画面に2枚見せる
                slidesToScroll: 1, //1回のスクロールで2枚の写真を移動して見せる
            }
        },
        {
            breakpoint: 767, //モニターの横幅が426px以下の見せ方
            settings: {
                slidesToShow: 1, //スライドを画面に1枚見せる
                slidesToScroll: 1, //1回のスクロールで1枚の写真を移動して見せる
            }
        }
    ]
});


// 単体
// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime() {

    //ふわっと動くきっかけのクラス名と動きのクラス名の設定
    $('.fadeUpTrigger').each(function() { //fadeInUpTriggerというクラス名が
        　　 var elemPos = $(this).offset().top - 50; //要素より、50px上の
        　　 var scroll = $(window).scrollTop();　　 var windowHeight = $(window).height();　　 if (scroll >= elemPos - windowHeight) {　　 $(this).addClass('fadeUp');　　 // 画面内に入ったらfadeInというクラス名を追記
            　　 } else {　　　 $(this).removeClass('fadeUp');　　 // 画面外に出たらfadeInというクラス名を外す
            　　 }　　 });

    //関数でまとめることでこの後に違う動きを追加することが出来ます
    $('.fadeDownTrigger').each(function() { //fadeInDownTriggerというクラス名が
        　　 var elemPos = $(this).offset().top - 50; //要素より、50px上の
        　　 var scroll = $(window).scrollTop();　　 var windowHeight = $(window).height();　　 if (scroll >= elemPos - windowHeight) {　　 $(this).addClass('fadeDown');　　 // 画面内に入ったらfadeDownというクラス名を追記
            　　 } else {　　　 $(this).removeClass('fadeDown');　　 // 画面外に出たらfadeDownというクラス名を外す
            　　 }　　 });


} //ここまでふわっと動くきっかけのクラス名と動きのクラス名の設定

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function() {
    fadeAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function() {
    fadeAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述




// 複数（順番）
function delayScrollAnime() {
    var time = 0.2; //遅延時間を増やす秒数の値
    var value = time;
    $('.delayScroll').each(function() {
        var parent = this; //親要素を取得
        var elemPos = $(this).offset().top; //要素の位置まで来たら
        var scroll = $(window).scrollTop(); //スクロール値を取得
        var windowHeight = $(window).height(); //画面の高さを取得
        var childs = $(this).children(); //子要素を取得

        if (scroll >= elemPos - windowHeight && !$(parent).hasClass("play")) { //指定領域内にスクロールが入ったらまた親要素にクラスplayがなければ
            $(childs).each(function() {

                if (!$(this).hasClass("fadeUp")) { //アニメーションのクラス名が指定されているかどうかをチェック

                    $(parent).addClass("play"); //親要素にクラス名playを追加
                    $(this).css("animation-delay", value + "s"); //アニメーション遅延のCSS animation-delayを追加し
                    $(this).addClass("fadeUp"); //アニメーションのクラス名を追加
                    value = value + time; //delay時間を増加させる

                    //全ての処理を終わったらplayを外す
                    var index = $(childs).index(this);
                    if ((childs.length - 1) == index) {
                        $(parent).removeClass("play");
                    }
                }
            })
        } else {
            $(childs).removeClass("fadeUp"); //アニメーションのクラス名を削除
            value = time; //delay初期値の数値に戻す
        }
    })
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function() {
    delayScrollAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function() {
    delayScrollAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述